// extracted by mini-css-extract-plugin
module.exports = {"faqContainer":"faq_faqContainer__C1ctY"};